import React from 'react';
import { Layout, Seo } from '@layout';
import { FaqList } from '@components/FaqList';
import { RecommendProducts } from '@sections/shared/GridView';
import { CenteredFaqSection } from '@sections/shared/CenteredFaqSection';
import { ValuePropsArg, ValuePropsSection } from '@components/ValuePropsSection';
import { ShopSection } from './ShopSection';
import { ShopRegistrySection } from './ShopRegistrySection';
import { BottomWave, Divider } from './ExternalBrandPage.styles';
import { ExternalBrandHeroSection } from './ExternalBrandHeroSection';

interface DepartmentDataProps {
  id: string;
  title: string;
  image: string;
  link: string;
}

interface ExternalBrandPageProps {
  brandPageData: Record<string, Record<string, string>>;
  page: MarcomPageName;
  idPrefix: string;
  valueProps: ValuePropsArg[];
  imageData: {
    heroImage: string;
    heroImageMobile: string;
  };
  departmentsData: DepartmentDataProps[];
  products: RecommendProducts;
  brand: string;
  faqQuestions: ReadonlyArray<{
    section: string;
    question: string;
    answer: string;
  }>;
}
export const ExternalBrandPage = ({
  brandPageData,
  page,
  idPrefix,
  imageData,
  valueProps,
  departmentsData,
  products,
  brand,
  faqQuestions,
}: ExternalBrandPageProps) => {
  return (
    <Layout transparentHeaderButtonVariant="primeWeddingWebsites" headerScrollThresholdVh={35} page={page} isTransparentHeader={true}>
      <Seo
        title={brandPageData.seo.title}
        canonicalURL={`https://withjoy.com/registry/${page}/`}
        description={brandPageData.seo.content}
        ogImage={'common/meta_share/registry.jpg'}
      />
      <ExternalBrandHeroSection idPrefix={idPrefix} heroImageData={imageData} heroData={brandPageData.hero} page={page} brand={brand} />
      <ValuePropsSection values={valueProps} elementId={`${page}-value-props`} />
      <Divider />
      <ShopRegistrySection shopTitle={brandPageData.shopRegistry.shopTitle} idPrefix={idPrefix} departmentsData={departmentsData} />
      <ShopSection shopSearchData={brandPageData.shopSearch} products={products} idPrefix={idPrefix} />
      <BottomWave src="baby-registry/joy-button/gold-thread-5.svg" optimization="default" />
      <CenteredFaqSection
        title={brandPageData.faqList.title}
        titleColor="neutra6"
        backgroundColor="humana1Light"
        sectionId={`${idPrefix}_FAQ`}
      >
        <FaqList accordion={true} questionNodes={faqQuestions} color="neutra6" isLinkHidden={true} />
      </CenteredFaqSection>
    </Layout>
  );
};
